<div class="opening-hours">
  <div class="opening-hours__state">
    <img src="../../../assets/img/circle_green.svg" alt="Open" *ngIf="state">
    <img src="../../../assets/img/circle_red.svg" alt="Closed" *ngIf="!state">
  </div>
  <div class="opening-hours__text" [innerHTML]="'OPENING_HOURS.TEXT_OPENED' | translate:{closeTime: todayCloseTime.hour}" *ngIf="state"></div>
  <div class="opening-hours__text" [innerHTML]="'OPENING_HOURS.TEXT_CLOSED' | translate" *ngIf="!state"></div>
</div>
